import React, { useState, useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";
import "./Sobre.css";

const Sobre: React.FC = () => {
  const { t } = useTranslation();
  const [currentIndex, setCurrentIndex] = useState(0);
  const autoPlayRef = useRef<NodeJS.Timeout | null>(null);

  // Array of images - for now just one, but easily expandable
  const images = [
    { src: "/sobre.png", alt: t("sobre.imageAlt") },
    { src: "/1.jpg", alt: t("sobre.imageAlt") },
    { src: "/2.jpg", alt: t("sobre.imageAlt") },
    { src: "/3.jpg", alt: t("sobre.imageAlt") },
    { src: "/4.jpg", alt: "Description 2" },
    { src: "/grupo.JPG", alt: "Description 3" },
    { src: "/costas.jpg", alt: "Description 3" },
  ];

  // Auto-play functionality
  useEffect(() => {
    const startAutoPlay = () => {
      autoPlayRef.current = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % images.length);
      }, 5000); // Change slide every 5 seconds
    };

    startAutoPlay();

    return () => {
      if (autoPlayRef.current) {
        clearInterval(autoPlayRef.current);
      }
    };
  }, [images.length]);

  // Reset auto-play when user manually changes slide
  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
    if (autoPlayRef.current) {
      clearInterval(autoPlayRef.current);
    }
    autoPlayRef.current = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % images.length);
    }, 5000);
  };

  // Handle image click to go to next slide
  const handleImageClick = () => {
    const nextIndex = (currentIndex + 1) % images.length;
    handleDotClick(nextIndex);
  };

  return (
    <section id="about" className="sobre-section">
      <div className="sobre-container">
        <div className="sobre-layout">
          {/* <div className="sobre-image">
            <div
              className="carousel-image-container"
              onClick={handleImageClick}
              style={{ cursor: "pointer" }}
            >
              {images.map((image, index) => (
                <img
                  key={index}
                  src={image.src}
                  alt={image.alt}
                  className={`sobre-img ${
                    index === currentIndex ? "active" : ""
                  }`}
                />
              ))}
            </div>
            {images.length > 1 && (
              <div className="carousel-dots">
                {images.map((_, index) => (
                  <button
                    key={index}
                    className={`carousel-dot ${
                      index === currentIndex ? "active" : ""
                    }`}
                    onClick={() => handleDotClick(index)}
                    aria-label={`Go to slide ${index + 1}`}
                  />
                ))}
              </div>
            )}
          </div> */}
          <div className="sobre-content">
            <h2 className="sobre-title section-title">{t("sobre.title")}</h2>
            <div className="section-description">{t("sobre.description")}</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Sobre;
